import { createFileRoute } from "@tanstack/react-router";

// `?open=<mã nhân sự>` — chuông "HR đã duyệt / từ chối" (QĐ 0289) mở thẳng hồ
// sơ người đó. Giá trị lạ thì bỏ qua, không làm hỏng trang.
export const Route = createFileRoute("/_app/staff")({
  validateSearch: (search: Record<string, unknown>): { open?: string } =>
    typeof search.open === "string" && search.open.trim() !== ""
      ? { open: search.open.trim() }
      : {},
});
